/**
 * workdayReminder.js
 *
 * The end-of-workday reminder is delivered ONLY by the server push (`metadata.type 'workday_reminder'`); the app no
 * longer schedules a local copy (it produced a duplicate banner). This module keeps the cancel helper so installs that
 * upgraded from a build that did schedule one never fire a stale local notification. No-op on web; never throws.
 *
 * @module helpers/workdayReminder
 */

import * as Notifications from 'expo-notifications';
import {Platform} from 'react-native';
import {reminderIdentifier} from './workdayRules';

const available = () => Platform.OS !== 'web'
    && Boolean(Notifications)
    && typeof Notifications.cancelScheduledNotificationAsync === 'function';

/**
 * Cancel any legacy locally scheduled workday reminder of the user (deterministic identifier).
 * @param {string} userId user id. @returns {Promise<void>}
 */
export const cancelWorkdayReminder = async (userId) => {
    if (!userId || !available()) {
        return;
    }

    try {
        await Notifications.cancelScheduledNotificationAsync(reminderIdentifier(userId));
    } catch (_e) {
        // Nothing pending / best effort.
    }
};
